import { render, staticRenderFns } from "./PartnerApplication.vue?vue&type=template&id=234a618a&"
import script from "./PartnerApplication.vue?vue&type=script&lang=js&"
export * from "./PartnerApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports